import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';
function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
interface ButtonProps extends HTMLMotionProps<'button'> {
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  children,
  ...props
}: ButtonProps) {
  const variants = {
    primary: 'bg-red-600 text-white hover:bg-red-700 border-2 border-transparent',
    outline: 'bg-transparent text-white border-2 border-white hover:bg-white hover:text-black',
    ghost: 'bg-transparent text-white hover:text-red-500 hover:bg-neutral-900/50'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };
  return <motion.button whileHover={{
    scale: 1.05,
    skewX: -10
  }} whileTap={{
    scale: 0.95
  }} className={cn('relative inline-flex items-center justify-center font-black uppercase tracking-wider transition-colors duration-200', 'skew-x-[-10deg]',
  // Permanent aggressive skew for the brand
  variants[variant], sizes[size], className)} {...props} data-id="element-184">
      <span className="skew-x-[10deg]" data-id="element-185">{children}</span>
    </motion.button>;
}